import {Directive, forwardRef} from '@angular/core';
import {NG_VALIDATORS} from '@angular/forms';
import {validateBban} from '@atlas/businesstypes';

import {AbstractValidatorDirective} from '../base/validator';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasBban]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BaseBbanValidator),
      multi: true,
    },
  ],
})
export class BaseBbanValidator extends AbstractValidatorDirective {
  protected readonly validatorFn = validateBban;
}
